import gql from 'graphql-tag';

const GET_REPEAT_VISITS = gql`
  query GetRepeatVisits($params: ReportInput!) {
    purchasesBySubWithMulPurchases(params: $params) {
      cashbackPercentage
      totalPurchases
      numberOfTransactors
      percentOfMerchantTotal
      aov
      startDate
      endDate
    }

    percentNewTransactors(params: $params) {
      cashbackPercentage
      percentRepeat
    }
  }
`;

const GET_REPEAT_VISITS_BY_SEGMENT = gql`
  query GetRepeatVisitsBySegment($params: ReportInput!) {
    purchasesBySubWithMulPurchasesBySegment(params: $params) {
      segmentId
      totalPurchases
      numberOfTransactors
      percentOfMerchantTotal
      aov
      startDate
      endDate
    }

    percentNewTransactorsBySegment(params: $params) {
      segmentId
      percentRepeat
    }
  }
`;

export { GET_REPEAT_VISITS_BY_SEGMENT, GET_REPEAT_VISITS };
